module.exports = __webpack_public_path__ + "img/advantage.51cce8a2.jpeg";